import { render, staticRenderFns } from "./StudyRecordTerm.vue?vue&type=template&id=01500f39"
import script from "./StudyRecordTerm.vue?vue&type=script&lang=js"
export * from "./StudyRecordTerm.vue?vue&type=script&lang=js"
import style0 from "./StudyRecordTerm.vue?vue&type=style&index=0&id=01500f39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports